import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import KmzDownloadNotificationBanner from '../../components/banners/KmzDownloadNotificationBanner';
import ZipDownloadNotificationBanner from '../../components/banners/ZipDownloadNotificationBanner';
import CloseoutNotificationBanner from '../../components/banners/CloseoutNotificationBanner';
import ProjectsMigratedBanner from '../../components/banners/ProjectsMigratedBanner';
import MobileOfflineBanner from '../../components/banners/MobileOfflineBanner';
import MobileBadConnectionAlert from '../../components/banners/MobileBadConnectionAlert';
import SyncSuccessfulBanner from '../../components/banners/SyncSuccessfulBanner';
import GenericTextBanner from '../../components/banners/GenericTextBanner';
import AnnouncementBanner from '../../components/banners/AnnouncementBanner';

import ModalBannerConstants from '../../constants/ModalBannerConstants';
import dataModel from '../../models/DataModel';

// TODO: consolodate banners into GenericTextBanner
// Add more banner comopnents here as needed - don't forget to add to CompanyLevelBanners set in DataModel.js
const BANNER_COMPONENTS = {
  [ModalBannerConstants.CLOSEOUT_NOTIFICATION_BANNER]: CloseoutNotificationBanner,
  [ModalBannerConstants.PROJECTS_MIGRATED_BANNER]: ProjectsMigratedBanner,
  [ModalBannerConstants.MOBILE_OFFLINE_BANNER]: MobileOfflineBanner,
  [ModalBannerConstants.SYNC_SUCCESSFUL_BANNER]: SyncSuccessfulBanner,
  [ModalBannerConstants.GENERIC_TEXT_BANNER]: GenericTextBanner,
  [ModalBannerConstants.ANNOUNCEMENT_BANNER]: AnnouncementBanner,
  [ModalBannerConstants.MOBILE_BAD_CONNECTION]: MobileBadConnectionAlert,
  [ModalBannerConstants.ZIP_DOWNLOAD_NOTIFICATION_BANNER]: ZipDownloadNotificationBanner,
  [ModalBannerConstants.KMZ_DOWNLOAD_NOTIFICATION_BANNER]: KmzDownloadNotificationBanner,
};

class GlobalBanner extends React.Component {
  constructor(props) {
    super(props);
    this.displayedBannerProps = {};
  }

  render() {
    const { bannerType, bannerProps } = this.props;
    const isMobile = dataModel.mobileBridge.isMobile;
    if(!bannerType) {
      // treat this as a request to remove all global banners...
      this.displayedBannerProps = {};
      return null;
    }
    if(isMobile && bannerProps && !bannerProps.isMobile){
      return null;
    }
    if(!isMobile && bannerProps && bannerProps.isMobile){
      return null;
    }
    let bannerStyle = {};
    let bannerClass = isMobile ? 'mobile-banner' : 'web-banner';
    if (bannerProps) {
      bannerProps.bannerType = bannerType;
      if (bannerProps.marginLeft) {
        bannerStyle.marginLeft = bannerProps.marginLeft;
        delete bannerProps.marginLeft;
      }
      if (bannerProps.width) {
        bannerStyle.width = bannerProps.width;
        delete bannerProps.width;
      }
      this.displayedBannerProps[bannerType] = bannerProps;
    }
    else {
      delete this.displayedBannerProps[bannerType];
    }

    const bannersProps = Object.values(this.displayedBannerProps);
    bannerStyle.height = 50 * bannersProps.length;  
    const banners = bannersProps.map((bannerProps) => {
      const Banner = BANNER_COMPONENTS[bannerProps.bannerType];
      return (
          <Banner key={bannerProps.bannerType} {...bannerProps} />
        );
    });
    return (
      <div className={'global-banner ' + bannerClass} style={bannerStyle}>
        {banners}
      </div>
    );
  }
}

GlobalBanner.propTypes = {
  /** If true, banner will only be displayed on mobile. The inverse is also true */
  isMobile: PropTypes.bool,
};

export default connect(state => state.main.globalBanner)(GlobalBanner);



// WEBPACK FOOTER //
// ./src/containers/GlobalBanner/index.js